<template lang="pug">
  .classifier-form
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
          .edit-select
            select.select(@change="changeEditSelect")
              option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            e-form-group(
              name="groro_number"
              inputType="input"
              label="Код объекта"
              :model="fields"
              tabView="tab1"
            )
            e-form-group(
              name="number"
              inputType="input"
              label="Номер решения Росприроднадзора"
              :model="fields"
              tabView="tab1"
            )
            e-form-group(
              name="dt"
              inputType="calendar"
              label="Дата решения Росприроднадзора"
              :model="fields"
              tabView="tab1"
              type="date"
            )
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { cadastr } from '@/api/api-endpoints'

export default {
  mixins: [formBaseMixin],
  data: () => {
    return {
      tabView: 'tab1',
      fields: {},
    }
  },
  computed: {
    tabs() {
      return [{ tab1: 'Общие сведения' }]
    },
  },
  methods: {
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return cadastr.groroItem(route.params.id)
    },
    getUpdateOrCreateUrl() {
      return cadastr.groroItem(this.$route.params.id)
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
    async getData() {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getItemEndpoint(this.$route),
      })
    },
  },
  created() {
    this.getData()
  },
}
</script>
